import React from "react";

const Menu = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
    <g id="list" transform="translate(-2 -5)">
      <line
        id="Ligne_204"
        data-name="Ligne 204"
        x2="13"
        transform="translate(8 6)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Ligne_205"
        data-name="Ligne 205"
        x2="13"
        transform="translate(8 12)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Ligne_206"
        data-name="Ligne 206"
        x2="13"
        transform="translate(8 18)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Ligne_207"
        data-name="Ligne 207"
        x2="0.01"
        transform="translate(3 6)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Ligne_208"
        data-name="Ligne 208"
        x2="0.01"
        transform="translate(3 12)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Ligne_209"
        data-name="Ligne 209"
        x2="0.01"
        transform="translate(3 18)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export { Menu };
